module.exports = __webpack_public_path__ + "static/img/Louis-Emmett .7668d79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Louis-Emmett .jpg
// module id = 2nr1
// module chunks = 0